import React from 'react'
import PropTypes from 'prop-types'
import {
  Card, Form, Input, Button, Modal,
} from 'antd'
import moment from 'moment'
import { ForbiddenPage } from 'components/elements'

const SUPPORT_SESSION_PERMISSION = 'manage-support-session-write'

const maskCode = code => '•'.repeat((code || '').length)

const SupportSessionForm = ({
  form, isGenerating, session, isRevealed,
  isConfirmModalOpen, password, isVerifying,
  handleGenerate, handleReset, openConfirmModal, closeConfirmModal,
  handleChangePassword, handleConfirmReveal, handleHide,
}) => {
  const { getFieldDecorator, validateFields } = form

  return (
    <div>
      <Form
        onSubmit={(e) => {
          e.preventDefault()
          validateFields((err, values) => {
            if (!err) {
              handleGenerate(values)
            }
          })
        }}
      >
        <Card className="mb-4">
          <h5 className="mb-4">Generate Kode Sesi Bantuan</h5>
          <p className="text-muted">
            Masukkan Nomor Peserta pelanggan yang sedang dibantu. Kode yang
            dihasilkan berlaku sebentar dan hanya boleh dibacakan langsung ke
            pelanggan melalui telepon.
          </p>
          <Form.Item label="Nomor Peserta">
            {getFieldDecorator('register_number', {
              rules: [{ required: true, message: 'Nomor Peserta wajib diisi' }],
            })(
              <Input type="number" placeholder="Masukan Nomor Peserta" disabled={!!session} />,
            )}
          </Form.Item>
          {!session && (
            <Button type="primary" htmlType="submit" loading={isGenerating}>
              Generate Kode
            </Button>
          )}
        </Card>
      </Form>

      {session && (
        <Card className="mb-4">
          <h6 className="mb-3">Kode Sesi Bantuan</h6>
          <div className="d-flex align-items-center">
            <span style={{ fontSize: '24px', letterSpacing: '4px', fontWeight: 'bold' }}>
              {isRevealed ? session.code : maskCode(session.code)}
            </span>
            {isRevealed ? (
              <Button className="ml-3" onClick={handleHide} icon="eye-invisible">Sembunyikan</Button>
            ) : (
              <Button className="ml-3" onClick={openConfirmModal} icon="eye">Tampilkan</Button>
            )}
          </div>
          <p className="text-muted mt-2 mb-0">
            {'Berlaku hingga '}
            {moment(session.expires_at).format('DD MMMM YYYY, HH:mm:ss')}
          </p>
          <Button className="mt-3" onClick={handleReset}>Generate Kode Baru</Button>
        </Card>
      )}

      <Modal
        title="Konfirmasi Password"
        centered
        visible={isConfirmModalOpen}
        onCancel={closeConfirmModal}
        footer={[
          <Button key="cancel" onClick={closeConfirmModal} disabled={isVerifying}>Batal</Button>,
          <Button
            key="confirm"
            type="primary"
            loading={isVerifying}
            onClick={handleConfirmReveal}
          >
            Konfirmasi
          </Button>,
        ]}
      >
        <p className="text-muted">
          Masukkan kembali password akun Anda untuk menampilkan kode ini.
        </p>
        <Input.Password
          value={password}
          onChange={handleChangePassword}
          placeholder="Masukkan password Anda"
          onPressEnter={handleConfirmReveal}
        />
      </Modal>
    </div>
  )
}

SupportSessionForm.propTypes = {
  form: PropTypes.object.isRequired,
  isGenerating: PropTypes.bool,
  session: PropTypes.object,
  isRevealed: PropTypes.bool,
  isConfirmModalOpen: PropTypes.bool,
  password: PropTypes.string,
  isVerifying: PropTypes.bool,
  handleGenerate: PropTypes.func.isRequired,
  handleReset: PropTypes.func.isRequired,
  openConfirmModal: PropTypes.func.isRequired,
  closeConfirmModal: PropTypes.func.isRequired,
  handleChangePassword: PropTypes.func.isRequired,
  handleConfirmReveal: PropTypes.func.isRequired,
  handleHide: PropTypes.func.isRequired,
}

SupportSessionForm.defaultProps = {
  isGenerating: false,
  session: null,
  isRevealed: false,
  isConfirmModalOpen: false,
  password: '',
  isVerifying: false,
}

const WrappedSupportSessionForm = Form.create({ name: 'supportSession' })(SupportSessionForm)

const SupportSession = ({ currentUser, ...rest }) => {
  if (currentUser.permissions && currentUser.permissions.indexOf(SUPPORT_SESSION_PERMISSION) > -1) {
    return <WrappedSupportSessionForm {...rest} />
  }
  return <ForbiddenPage />
}

SupportSession.propTypes = {
  currentUser: PropTypes.object.isRequired,
}

export default SupportSession
